const apiBase = import.meta.env.DEV
  ? ((import.meta.env["VITE_API_BASE_URL"] as string | undefined)?.replace(
      /\/$/,
      "",
    ) ?? "")
  : "";
const knownNames = new Set([
  "Error",
  "TypeError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "AggregateError",
]);
let sent = 0;

export function reportBrowserError(
  error: unknown,
  kind: "exception" | "rejection" | "boundary",
) {
  if (typeof window === "undefined" || sent >= 10) return;
  sent++;
  const errorName =
    error instanceof Error && knownNames.has(error.name)
      ? error.name
      : "UnknownError";
  const text =
    error instanceof Error ? `${error.name}\n${error.stack ?? ""}` : "unknown";
  const section =
    window.location.pathname
      .split("/")[1]
      ?.toLowerCase()
      .match(/^[a-z0-9-]{1,40}$/)?.[0] ?? "root";
  if (!globalThis.crypto?.subtle || typeof TextEncoder === "undefined") return;
  void crypto.subtle
    .digest("SHA-256", new TextEncoder().encode(text.slice(0, 2048)))
    .then((bytes) =>
      [...new Uint8Array(bytes)]
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join(""),
    )
    .then((fingerprint) =>
      fetch(`${apiBase}/v1/telemetry/browser-error`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        credentials: "omit",
        keepalive: true,
        body: JSON.stringify({
          app: "storefront",
          kind,
          errorName,
          fingerprint,
          section,
        }),
      }),
    )
    .catch(() => undefined);
}

export function installBrowserErrorTelemetry() {
  const onError = (event: ErrorEvent) =>
    reportBrowserError(event.error, "exception");
  const onRejection = (event: PromiseRejectionEvent) =>
    reportBrowserError(event.reason, "rejection");
  window.addEventListener("error", onError);
  window.addEventListener("unhandledrejection", onRejection);
  return () => {
    window.removeEventListener("error", onError);
    window.removeEventListener("unhandledrejection", onRejection);
  };
}
